import { action, observable, set } from "mobx";

export default class TourCheckoutPageLinks {
  /**
   * @property {string|null}
   */
  @observable otherProduct1CheckoutPageLink = null;

  constructor(data) {
    if (data !== undefined) {
      this.setData(data);
    }
  }

  @action
  setData(data) {
    set(this, data);
  }
}
